import { render } from "./left_menu.vue?vue&type=template&id=5b077640"
import script from "./left_menu.vue?vue&type=script&lang=js"
export * from "./left_menu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/willson/Desktop/project/welove/admin_js/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__